import React from 'react';
import { Icon } from './Icon.js';
export const IconWipFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6.98926 2.12305C6.45426 1.98721 6 2.44789 6 3V6L3.87891 8.12109C3.48838 8.51162 3.48425 9.15821 3.95898 9.44043C4.55651 9.79564 5.25442 10 6 10C8.20905 9.9999 10 8.20908 10 6C10 4.13252 8.71962 2.56356 6.98926 2.12305Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWipFill12.js.map